module.exports = __webpack_public_path__ + "images/82de3a3af751b10373950c65851ef77a.svg";